import useTenantFeatures from '../../hooks/useTenantFeatures';
import usePermissions from '../../hooks/usePermissions';
import usePlanControl from '../../hooks/usePlanControl';

// Who may do what with check sets, for the BUTTONS (spec §4, §7-6). The server
// decides for real on every request; this only keeps a button from being drawn
// for somebody it would refuse.
//
//   featureOn          the hospital has `check_sets` (tenant features — NOT
//                      FeatureGuard, which is the doctor-plan gate)
//   canRecord          the doctor, or staff whose role has `checks.record`.
//                      NOT the admin (owner, 28 Sep 2026: the admin defines
//                      the sets, never records — 403 CHECKS_RECORDER_ONLY).
//                      Web can() is false for a doctor and true for the
//                      admin, so both are tested by role.
//   canManageHospital  the admin, or staff with `checks.manage`
//   planOn             a DOCTOR's plan carries `check_sets` (owner, 1 Oct
//                      2026: refused by the server without it). Always true
//                      for everyone else — staff recording on a doctor's
//                      visit is judged by the server, and RecordReadingsModal
//                      shows its reason.
//
// Call it once per screen and pass the answer down: each call reads the
// tenant features and the permissions.
export default function useCheckAccess() {
    const role = (typeof localStorage !== 'undefined' && localStorage.getItem('Role')) || '';
    const { has } = useTenantFeatures();
    const { can } = usePermissions();
    const planOn = usePlanControl('check_sets');
    const featureOn = has('check_sets');
    const canRecord = featureOn && planOn && role !== 'admin' && (role === 'doctor' || can('checks.record'));
    const canManageHospital = featureOn && (role === 'admin' || (role === 'user' && can('checks.manage')));
    return { role, featureOn, planOn, canRecord, canManageHospital };
}
